import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import axios from "axios";
//import logo
import AnimatedLogo from "../Components/Common/AnimatedLogo";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import TwoColumnLayout from "./TwoColumnLayout";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import config from "../config";

const Sidebar = ({ layoutType } : any) => {
  const [databaseStatus, setDatabaseStatus] = useState<{
    currentDatabase: string;
    isProduction: boolean;
    environment: string;
  } | null>(null);
  const [sidebarSize, setSidebarSize] = useState<string>('lg');

  useEffect(() => {
    // Check sidebar size
    const checkSidebarSize = () => {
      const sidebarSizeAttr = document.documentElement.getAttribute('data-sidebar-size');
      if (sidebarSizeAttr) {
        setSidebarSize(sidebarSizeAttr.includes('sm') ? 'sm' : 'lg');
      }
    };

    checkSidebarSize();
    
    // Watch for sidebar size changes
    const observer = new MutationObserver(checkSidebarSize);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-sidebar-size']
    });

    // Fetch database status
    const fetchDatabaseStatus = async () => {
      try {
        const response = await axios.get(`${config.api.API_URL}/dev/database-status`);
        if (response.data.success) {
          setDatabaseStatus(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching database status:', error);
      }
    };

    fetchDatabaseStatus();
    
    // Listen for database switch events
    const handleDatabaseSwitch = () => {
      fetchDatabaseStatus();
    };
    
    window.addEventListener('database-switched', handleDatabaseSwitch);
    
    // Refresh every 30 seconds
    const interval = setInterval(fetchDatabaseStatus, 30000);
    
    return () => {
      observer.disconnect();
      window.removeEventListener('database-switched', handleDatabaseSwitch);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay && verticalOverlay[0]) {
      const handleClick = () => {
        document.body.classList.remove("vertical-sidebar-enable");
      };
      verticalOverlay[0].addEventListener("click", handleClick);
      
      // Cleanup function to remove event listener
      return () => {
        if (verticalOverlay[0]) {
          verticalOverlay[0].removeEventListener("click", handleClick);
        }
      };
    }
  }, []); // Add empty dependency array

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    // Add null check for document.documentElement
    if (!document.documentElement) {
      return;
    }
    
    // Cache the current sidebar size to avoid multiple DOM accesses
    const currentSidebarSize = document.documentElement.getAttribute('data-sidebar-size');
    
    if (currentSidebarSize === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (currentSidebarSize === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  return (
    <React.Fragment>
      {/* Dev Environment - Wine Red Sidebar */}
      {config.app.environment !== 'production' && (
        <style>{`
          .app-menu.navbar-menu {
            --vz-vertical-menu-bg: #6d1a36 !important;
            --vz-vertical-menu-item-color: rgba(255, 255, 255, 0.85) !important;
            --vz-vertical-menu-item-hover-color: #ffffff !important;
            --vz-vertical-menu-item-active-color: #ffffff !important;
            --vz-vertical-menu-sub-item-color: rgba(255, 255, 255, 0.7) !important;
            --vz-vertical-menu-sub-item-hover-color: #ffffff !important;
            --vz-vertical-menu-border: rgba(255, 255, 255, 0.1) !important;
          }
        `}</style>
      )}

      <div className="app-menu navbar-menu">
        {/* Database Badge - only show in non-production environments */}
        {config.app.environment !== 'production' && (
          <div style={{ position: 'absolute', top: '5px', left: '10px', zIndex: 1000 }}>
            <span className={`badge ${databaseStatus?.isProduction ? 'bg-success' : 'bg-warning text-dark'}`} style={{ fontSize: '0.5rem', padding: '0.18rem 0.35rem' }}>
              {databaseStatus ? (databaseStatus.isProduction ? 'live-db' : 'dev-db') : 'loading...'}
            </span>
          </div>
        )}
        
        
        {/* Version Badge */}
        <div style={{ position: 'absolute', top: '5px', right: '10px', zIndex: 1000 }}>
          <span className="badge bg-warning text-dark" style={{ fontSize: '0.5rem', padding: '0.18rem 0.35rem' }}>
            v{config.app.version}
          </span>
        </div>
        
        <div className="navbar-brand-box" style={{ marginTop: '15px', width: '100%', padding: 0, overflow: 'hidden' }}>
          <Link to="/" className="logo" style={{ display: 'block', width: '100%', textAlign: 'center' }}>
            <AnimatedLogo 
              height={sidebarSize === 'sm' ? 50 : 180} 
              responsive={true}
              animate={false}
            />
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
            style={{ position: 'absolute', right: '10px', top: '10px' }}
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
